import { GLEnvironment, GrowelabEnv } from 'src/app/common/types/env';
import { environment as defaultEnv } from './environment.default';

export const environment: GrowelabEnv = {
  ...defaultEnv,
  environment: GLEnvironment.STAGING,
  apiUrl: 'https://staging.api.engage2learn.org',
  glaiApiUrl: 'https://staging-ai.growelab.app/api/v1', // URL of GLAI API backend
  pusher: {
    key: 'cfe6b01015d18a2c6213',
    cluster: 'us2',
  },
  googleAnalyticsID: 'G-ZLJL57QJHS',
  SENTRY_ORG: 'engage2learn',
  SENTRY_PROJECT: 'growelab-web',
  SENTRY_KEY:
    '519b763d3b944feb82e5349b62abae25d6c7b66c6c8e41db87275eaa884d75dc',
  cleverRedirectURI: 'https://staging.growelab.app/clever-auth',
  getstream_appid: '1294597',
  getstream_key: 'f853nr8yjdxd',
  ckEditor: {
    ...defaultEnv.ckEditor,
    licenseKey:
      'eyJhbGciOiJFUzI1NiJ9.eyJleHAiOjE3OTQwOTU5OTksImp0aSI6ImQ4MWJkMThmLTQ1YmMtNDk0ZC04MmY0LWI0NjI1ZjYyM2UwYiIsImxpY2Vuc2VkSG9zdHMiOlsiKi5ncm93ZWxhYi5hcHAiLCIqLmVuZ2FnZTJsZWFybi5vcmciXSwidXNhZ2VFbmRwb2ludCI6Imh0dHBzOi8vcHJveHktZXZlbnQuY2tlZGl0b3IuY29tIiwiZGlzdHJpYnV0aW9uQ2hhbm5lbCI6WyJjbG91ZCIsImRydXBhbCJdLCJ3aGl0ZUxhYmVsIjp0cnVlLCJmZWF0dXJlcyI6WyJEUlVQIiwiRE8iLCJGUCIsIlNDIiwiVE9DIiwiVFBMIiwiUE9FIiwiQ0MiLCJNRiIsIkUyUCIsIkUyVyIsIk1MTCIsIlNFRSIsIkVDSCIsIkVJUyIsIkxIIiwiRk9PIiwiQ01UIiwiVEMiLCJSSCIsIlJFIiwiUkNNVCIsIlJUQyIsIlJSSCIsIklXIl0sInZjIjoiNWI2ZTQ3OTkifQ.K1liHV-vlvZbJMwdQNcM2Hu61TdwG0N9NGh1RkAVohtzgh0EqoPXvBRjap7cRPzaToIPi88PeUxUo2fy6WM-6g',
    environmentId: 'HQq37nwQP3lp5pkhdBr8',
  },
};
